import {
   clsx
  ,styled
  ,Fab
} from 'external/material'

import LinkBehavior from 'components/LinkBehavior'
import {findGlobalIndex} from 'utils/assessment'
import useAssessment from 'hooks/assessment'
import useSession from 'hooks/session'
 
const QuestionLinkContainer = styled(Fab)(linkStyles)

export default function QuestionLink ({section, sections, question, index}) {

  const {assessment = {}} = useAssessment()
  const {answers = {}} = assessment
  const answer = answers[question.id] || {}
  const {assessmentId, questionId, sectionId, navigation} = useSession()

  const selected = question.id == questionId && section.id == sectionId

  const marked = answer.pending == true
  const answered = answer.completed && !marked

  const onClick = e => selected && e.preventDefault()
  const className = clsx("root", {selected, marked, answered})
  const to = assessmentId && navigation.assessmentQuestion.link({sectionId: section.id, questionId: question.id}) 

  const globalIndex = findGlobalIndex(question.id, sections)

  return (
    <QuestionLinkContainer {...{size: 'small', onClick, className, to, component: LinkBehavior}}>
      {globalIndex + 1}
    </QuestionLinkContainer>
  )
}

export function QuestionLinkDummy () {
  return (
    <QuestionLinkContainer size="small" className={clsx("root", "dummy")}>0</QuestionLinkContainer>
  )
}

function linkStyles (theme) {
  return {
    "&.root": {
      backgroundColor: '#f3f4f6',
      color: '#a3aab0',
      boxShadow: 'none',
      marginRight: 10,
      "& .MuiFab-label": {
        paddingTop: 2
      },
      "&:last-child": {
        marginRight: 0
      },
      "&.dummy": {
        visibility: 'hidden'
      },
      "&.marked": {
        backgroundColor: '#ef0e0a',
        color: '#fff',
      },
      "&.answered": {
        backgroundColor: '#52aa5e',
        color: '#fff',
      },
      "&.selected": {
        backgroundColor: '#000',
        color: '#fff',
        cursor: 'default'
      }
    }
  }
}
